import React from "react";
import { ResponsiveContainer } from "recharts";

/** Recharts needs a parent with explicit pixel dimensions (not unmeasured flex/%). */
export default function ChartBox({ height = 220, width = "100%", ready = true, debounce = 48, children }) {
    if (!ready) {
        return (
            <div
                className="w-full min-w-0 flex items-center justify-center text-slate-600 text-[10px]"
                style={{ height, minHeight: height }}
            />
        );
    }
    return (
        <div className="w-full min-w-0" style={{ height, minHeight: height }}>
            <ResponsiveContainer width={width} height={height} minWidth={0} debounce={debounce}>
                {children}
            </ResponsiveContainer>
        </div>
    );
}
